import freeze from '../../../../../../lib/deep-freeze';

import { Button, ButtonType } from './interface';
import { randomId } from '../../lib/random-id';

export function createTopMenuButton(): Button {
  return createButton({ type: ButtonType.topMenu } as any);
}

export function createImageToolbarButton(): Button {
  return createButton({ type: ButtonType.imageToolbar } as any);
}

export function createButton({
  id = randomId(),
  title = 'initial title' as any,
  icon = 'initial icon',
  extraClass = 'initial class',
  type = undefined,
  onClick = ({ insertContent, insertToken, selection, tokenData }) => {},
  attributes = {},
  state = () => '',
} = {}): Button {
  return freeze({
    id,
    title,
    icon,
    extraClass,
    type,
    onClick,
    attributes,
    state,
  });
}
